import React, {useState} from 'react';

import ConfirmDialog from './ConfirmDialog.js';
import SleepLogTable from './SleepLogTable.js';
import SleepLogGraph from './SleepLogGraph.js';
//import TabPanel from './TabPanel.js';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CircularProgress from "@material-ui/core/CircularProgress";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from '@material-ui/core/FormControl';
import Box from '@material-ui/core/Box';
import Snackbar from '@material-ui/core/Snackbar';

//import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';

//import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
//import Checkbox from '@material-ui/core/Checkbox';

import {firestore} from './firebase.js';
//import {UserContext} from './UserContext.js';
import {useCollection} from 'react-firebase-hooks/firestore';

import {CSVLink} from 'react-csv';


const useStyles = makeStyles((theme) => ({
      textForm: {
        textAlign: "left",
        //flexGrow: 1,
        //marginLeft:theme.spacing(1),
        //padding: theme.spacing(2),
        //margin: theme.spacing(2),
      },
      text: {
        textAlign: "center",
        //padding: theme.spacing(2),
        //margin: theme.spacing(2),
      },
      textExplanation: {
        textAlign: "justify",
        //padding: theme.spacing(2),
        //margin: theme.spacing(2),
      },
      select: {
        minWidth: 250,
        marginLeft:theme.spacing(3),
        //alignItems: "right",
        //marginLeft: "auto",
        //marginRight: 20,
      },
      table: {
          minWidth: 650,
      },
      graph: {
        maxWidth: 450,
        maxHeight: 450,
        margin: 'auto',
      },
      paper: {
        justifyContent: 'center',
        margin: 'auto',
        flexGrow: 1,
      }
  })); 


export default function SleepLogHistory(props) {
    const classes = useStyles();
    const {user} = props;
    const [commentOpen, setCommentOpen] = useState(false); // privacy dialog boolean
    const [currentComment, setCurrentComment] = useState("No Comment");
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [currentDocumentID, setCurrentDocumentID] = useState("");
    const [tabValue, setTabValue] = useState(0);
    const [dataPointsShown, setDataPointsShown] = useState(0);
    const defaultQualityOptions = ["Very Poor", "Poor", "Decent", "Good", "Very good"];
    const dataPointOptions = [{value: 0, text: "Show All Entries"}, {value:5, text: "Show Last 5 Entires"}, {value:10, text: "Show Last 10 Entries"}, {value:20, text:"Show Last 20 Entries"}];
    const [entryDeletedNotice, setEntryDelectedNotice] = useState(false);

    // HANDLE SHOWING COMMENTS DIALOG
    function handleCommentOpen(comment) {
        setCommentOpen(true);
        if (comment !== "") {
            setCurrentComment(comment);
        } else {
            setCurrentComment("No Comment");
        }
      }
    
      function handleCommentClose () { // If pt agrees to privacy, allow to move forward to app
        setCommentOpen(false);
      }

      // HANDLE DELETE DOCUMENT DIALOG
      function handleConfirmDeleteOpen(id) {
          setCurrentDocumentID(id);
          setConfirmDeleteOpen(true);
      }

      function handleConfirmDeleteAgree() {
        setConfirmDeleteOpen(false);
        firestore.collection(user ? `Users/${user.uid}/sleep-logs` : "Users").doc(currentDocumentID).delete()
        .then(()=>setEntryDelectedNotice(true));
        setCurrentDocumentID("");
      }

      function handleConfirmCancel() {
          setConfirmDeleteOpen(false);
          setCurrentDocumentID("");
      }

      const handleEntryDeletedNoticeClose  = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        if (event) {
          event.preventDefault();
        };
        setEntryDelectedNotice(false);
      };

      // HANDLE TAB VALUE CHANGE
      function handleTabValueChange(event, newValue) {
        event.preventDefault();
        setTabValue(newValue);
      }

      
      // HANDLE DATA POINT CHANGE
      function handleDataPointsShownChange(event) {
        setDataPointsShown(event.target.value);
      }

      const showSelectDataPoints = <><FormControl className={classes.select}>
      <InputLabel htmlFor="number-of-data-points">Entries</InputLabel>
        <Select id="number-of-data-points" value={dataPointsShown} onChange={handleDataPointsShownChange}>
              {dataPointOptions.map((option)=><MenuItem value={option.value} key={option.value}>{option.text}</MenuItem>)}
        </Select>
      </FormControl></>;

    //Load Data
    // Note "asc" for ascending and "desc" for descenging order
    // orderBy = order by bedtime and in descending order
    const [value, loading , error] = useCollection(
        firestore.collection(user ? `Users/${user.uid}/sleep-logs` : "Users").orderBy("bedtime", "desc"), //only load if user is logged in
        {
          snapshotListenOptions: { includeMetadataChanges: true },
        }
      );

      // Prep data to create a CSV
      const csvDataHeader = ["Date", "Sleep Efficiency (%)", "Bedtime (HH:MM)", "Lights Out (HH:MM)", "Time To Fall Asleep (Latency, Hours)", "Nightime Awakenings (In Bed, Min)", "Nightime Awakenings (Out Of Bed, Min)", "Awake Time (HH:MM)", "Comments", "Sleep Quality"];
      const csvDataBody = () => {
        if (value) {
          return value.docs.map(doc=>[doc.get("bedtime").toDate().toLocaleDateString("en-US"), doc.get("sleepEfficiency"), doc.get("bedtime").toDate().toLocaleTimeString("en-US"), doc.get("lightsOut").toDate().toLocaleTimeString("en-US"), doc.get("latency"), doc.get("awakeningsInBed"), doc.get("awakeningsOutOfBed"), doc.get("awake").toDate().toLocaleTimeString("en-US"), doc.get("comments"), defaultQualityOptions[doc.get("sleepQuality")]]);
        }
        return [];
      }
      const csvData = [csvDataHeader, ...csvDataBody()];

      const graphData = (type) => { //data type such as "sleepEfficiency"
        if (value) {
            const graphData = value.docs.map(doc=>{
            return {
                x: `${doc.get("bedtime").toDate().getMonth()+1}/${doc.get("bedtime").toDate().getDate()}`, // Display MM/DD
                y: doc.get(type),
                label: "",
            };
        });
        if (dataPointsShown===0) {
            return graphData.reverse();
        }
        return graphData.slice(0,dataPointsShown).reverse(); // make descending instead of ascending, slice to length
    }
    return [];
    };

    // LIST OF TYPES AND SUFFIX TO SHOW ON GRAPH
    const graphDataTypeList = [{type: "sleepEfficiency", suffix: "%"}, {type: "totalTimeInBed", suffix: "h"}, {type: "totalSleepTime", suffix: "h"}, {type: "latency", suffix: "min"}, {type: "awakeningsInBed", suffix: "min"}, {type: "awakeningsOutOfBed", suffix: "min"}, {type: "sleepQuality", suffix: ""}];
  

    ////////////////////////
    //Display results///////
    ////////////////////////

    if (error) {
        return <Typography>Error: {JSON.stringify(error)}</Typography>;
    } else if (loading) {
        return  <CircularProgress />;
    } else if (user && value) { //Only show this if user is logged in and there is a stored value
        return <>
          <SleepLogTable user={user} value={value} onCommentOpen={handleCommentOpen} onConfirmDeleteOpen={handleConfirmDeleteOpen}/>
          <br /><br />
        <Typography><Button variant="contained" color="inherit"><CSVLink data={csvData} filename={`psych-apps_sleep-log.csv`}>Download Spreadsheet (CSV*)</CSVLink></Button></Typography>
        <br />
        <Typography variant="subtitle2" color="inherit">*CSV stands for "Comma Separated Values." It is a shareable file that can be opened on Excel or Google Sheets. This document can be used to send your log to your mental health provider or for your own records.</Typography>
          <br /><br />
          <Typography color="inherit" variant="h5"><strong>Graphs - A Closer Look</strong></Typography>
          <br/>
          <Paper className={classes.paper}>
          <Tabs value={tabValue} onChange={handleTabValueChange} variant="scrollable" scrollButtons="auto">
            <Tab label={"Efficiency"}/>
            <Tab label={"Time In Bed"}/>
            <Tab label={"Sleep Time"}/>
            <Tab label={"Latency"}/>
            <Tab label={"Awakenings In Bed"}/>
            <Tab label={"Awakenings Out Of Bed"}/>
            <Tab label={"Sleep Quality"} />
          </Tabs>
        <br/>
        {showSelectDataPoints}
        <br/>
        <Box className={classes.graph}>
          <SleepLogGraph data={graphData(graphDataTypeList[tabValue].type)} labelSuffix={graphDataTypeList[tabValue].suffix} />
        </Box>
        </Paper>
        <ConfirmDialog title={"Comments"} description={currentComment} agree="OK" disagree={null} open={commentOpen} onCloseClick= {null} onAgreeClick={handleCommentClose}/>
        <ConfirmDialog title={"Erase?"} description={`Erase Data From ${currentDocumentID}?`} agree="Yes" disagree="Cancel" open={confirmDeleteOpen} onCloseClick= {handleConfirmCancel} onAgreeClick={handleConfirmDeleteAgree}/>
        <Snackbar open={entryDeletedNotice} autoHideDuration={3000} onClose={handleEntryDeletedNoticeClose} message="Entry deleted." action={<Button color="primary" onClick={handleEntryDeletedNoticeClose}>OK</Button>}/>
        </>;
    } 

    return null;
}

/*

        <TabPanel tabValue={tabValue} index={0}>
          <SleepLogTable user={user} value={value} onCommentOpen={handleCommentOpen} onConfirmDeleteOpen={handleConfirmDeleteOpen}/>
        </TabPanel>
        <TabPanel tabValue={tabValue} index={1}>
          <SleepLogGraph data={graphData("sleepEfficiency")} labelSuffix="%" />
        </TabPanel>
        <TabPanel tabValue={tabValue} index={2}>
          <SleepLogGraph data={graphData("totalTimeInBed")} labelSuffix="h" />
        </TabPanel>
        <TabPanel tabValue={tabValue} index={3}>
            <SleepLogGraph data={graphData("totalSleepTime")} labelSuffix="h" />
        </TabPanel>
        <TabPanel tabValue={tabValue} index={4}>
          <SleepLogGraph data={graphData("latency")} labelSuffix="min" />
        </TabPanel>
        <TabPanel tabValue={tabValue} index={5}>
          <SleepLogGraph data={graphData("awakeningsInBed")} labelSuffix="min" />
        </TabPanel>
        <TabPanel tabValue={tabValue} index={6}>
          <SleepLogGraph data={graphData("awakeningsOutOfBed")} labelSuffix="min" />
        </TabPanel>
        <TabPanel tabValue={tabValue} index={7}>
          <SleepLogGraph data={graphData("sleepQuality")} labelSuffix="" />
        </TabPanel> */
